import { DeviceProvider } from './device';

export { 
  DeviceProvider
}


// WEBPACK FOOTER //
// ./src/providers/device/index.ts